import React from 'react';
import { MarkerType } from '@xyflow/react';
import { EDGE_COLORS, STROKE_WIDTH } from './index';
type MarkerProps = {
  id: string;
  color: string;
  width?: number;
  height?: number;
  markerUnits?: string;
  strokeWidth: number;
  orient?: string;
};
const Marker = (_ref: MarkerProps) => {
  let {
    id,
    color,
    width = 10,
    height = 10,
    markerUnits = "strokeWidth",
    orient = "auto-start-reverse"
  }: MarkerProps = _ref;
  return <marker className='react-flow__arrowhead' id={id} markerWidth={"".concat(width)} markerHeight={"".concat(height)} viewBox='-25 -18 50 36' markerUnits={markerUnits} orient={orient} refX='0' refY='0' data-sentry-element="marker" data-sentry-component="Marker" data-sentry-source-file="marker-definitions.tsx">
      <polyline style={{
      fill: color,
      stroke: color,
      strokeWidth: 0
    }} strokeLinecap='round' strokeLinejoin='round' points='-25,-18 0,0 -25,18' data-sentry-element="polyline" data-sentry-source-file="marker-definitions.tsx" />
    </marker>;
};
const COLOR_DEFINITIONS: MarkerProps[] = Object.entries(EDGE_COLORS).map(_ref2 => {
  let [type, color] = _ref2;
  return {
    id: type,
    type: MarkerType.Arrow,
    color,
    strokeWidth: STROKE_WIDTH
  };
});
export const ColoredMarkerDefinitions = () => {
  return <svg className='react-flow__marker' style={{
    position: "absolute",
    width: 0,
    height: 0,
    overflow: "hidden"
  }} data-sentry-element="svg" data-sentry-component="ColoredMarkerDefinitions" data-sentry-source-file="marker-definitions.tsx">
      <defs data-sentry-element="defs" data-sentry-source-file="marker-definitions.tsx">
        {COLOR_DEFINITIONS.map((marker: MarkerProps) => <Marker key={marker.id} {...marker} />)}
      </defs>
    </svg>;
};
ColoredMarkerDefinitions.displayName = "MarkerDefinitions";